(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', async function () {
        var form = btn.closest('form');
        if (!form) return;

        var variantInput = form.querySelector('[name="id"]');
        var quantityInput = form.querySelector('[name="quantity"]');
        var variantId = variantInput ? variantInput.value : null;
        var quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = 'Loading...';

        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: quantity })
          });

          if (res.ok) {
            window.location.href = '/checkout';
          } else {
            btn.disabled = false;
            btn.textContent = 'Buy it now';
          }
        } catch (e) {
          btn.disabled = false;
          btn.textContent = 'Buy it now';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
